<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl" persistent fluid scrollable)
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('edit_member') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.py-8
      .text-md.font-medium.mb-4 {{ $t('change_phone_number_team_member') }}
      y-phone-input.mb-8(v-model="phone")
    v-divider

    v-card-actions.px-6.py-3
      v-spacer
      v-btn.button-md.primary400--text(@click="showDialog = false" text) {{ $t('back') }}
      v-btn.button-md.white--text(@click="confirm" :loading="isLoading" color="info" depressed) {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['open', 'member'],
  data: () => ({
    phone: '',
    isLoading: false,
    rules: {
      phone: [
        v => !!v || 'Phone Number is required',
        v => /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/.test(v) || 'Phone Number must be valid',
      ]
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.phone = this.member.phone
  },
  methods: {
    ...mapActions(['showMessage']),
    phoneSanitized () {
      let phone = this.phone.replace(/ /g,'').replace(/\+/g, '').replace(/-/g, '')
      if (phone.charAt(0) === '0') {
        phone = '6' + phone
      }
      return phone
    },
    confirm () {
      const params = {
        phone: this.phoneSanitized(),
        role: 5
      }
      this.isLoading = true
      this.$axios.patch(`/members/${this.member.id}/`, params)
        .then(() => {
          this.showDialog = false
          this.showMessage(['success', this.$t('success_message.member_edited')])
          this.$emit('edited')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>